import store from '../../store/store';
import isValidClause, { isValidSection } from '../../utils/isValidClause';
export default function getSectionCompletionStatus(sectionType, sectionClauseIds) {
    var focusedClauseId = store.inboxRulesEditState.focusedClauseId;
    // name section is a special case -- no clause Id
    if (sectionType == 'name') {
        if (focusedClauseId == 'name') {
            return 2 /* InProgress */;
        }
        else if (store.inboxRulesEditState.ruleName &&
            store.inboxRulesEditState.ruleName.trim().length > 0) {
            return 1 /* Complete */;
        }
        else {
            return 0 /* Incomplete */;
        }
    }
    // we are guaranteed to have at lease one clause in a section
    var firstClause = store.inboxRulesEditState.clauseMap.get(sectionClauseIds[0]);
    if (sectionClauseIds.indexOf(focusedClauseId) > -1) {
        return 2 /* InProgress */;
    }
    else if (isValidSection(sectionType) &&
        firstClause.clauseType &&
        isValidClause(sectionClauseIds[0])) {
        // Possible for valid sections to be incomplete (e.g. empty optional section is still valid)
        // check that there is at least 1 valid clause in section
        return 1 /* Complete */;
    }
    else {
        return 0 /* Incomplete */;
    }
}
//# sourceMappingURL=getSectionCompletionStatus.js.map